import { ZfFormattedContent, ZfStack, ZfStatistic, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { LiquidityCalculatorMetricsDto } from '../../app/api/generated/client';
import { formatAmount } from '../../app/utils/renderUtils';

interface ILiquidityPlannerHeaderProps extends LiquidityCalculatorMetricsDto {
    currency: string;
}

export const LiquidityPlannerTitleBar: FunctionComponent<ILiquidityPlannerHeaderProps> = ({
    totalBankableAssets,
    totalCash,
    availableInvestmentAmount,
    currency,
}) => {
    const { t } = useTranslation();

    const renderStat = (label: string, value: number, valueSize: 'extra-large' | 'large', bold = false) => (
        <ZfStatistic size="medium" label={label} className={bold ? 'liquidity-planner__amount--bold' : undefined}>
            <ZfFormattedContent value={formatAmount(value, false, undefined, true)} size={valueSize} color={bold ? 'emphasis' : undefined}>
                <span slot="leading-text">{currency}</span>
            </ZfFormattedContent>
        </ZfStatistic>
    );

    return (
        <ZfStack direction="row" justify="space-between" alignment="center" className="liquidity-planner__title-bar">
            <ZfTypography variant="heading-medium">{t('liquidityPlannerTitle')}</ZfTypography>
            <ZfStack direction="row" spacing="extra-large" alignment="center">
                {renderStat(t('liquidityPlannerTotalBankableAssets'), totalBankableAssets, 'large')}
                {renderStat(t('liquidityPlannerTotalCash'), totalCash, 'large')}
                <div className="liquidity-planner__hero-card">
                    {renderStat(t('liquidityPlannerAvailableInvestmentAmount'), availableInvestmentAmount, 'extra-large', true)}
                </div>
            </ZfStack>
        </ZfStack>
    );
};
